import React, { useEffect, useState } from "react";
import Datatable from "core/pagination/datatable";
import { Link } from "react-router-dom";
import { Book, BookOpen, Edit, Eye, PlusCircle } from "react-feather";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useTableSearch } from "core/Operations/useTableSearch";
import TableTop from "Components/UI/TableTop";
import { all_routes } from "Router/all_routes";
import { endOfMonth, format, set, startOfMonth } from "date-fns";
import dayjs from "dayjs";
import { DatePicker } from "antd";

import { useGetAuditLogListQuery } from "AppQuries/setting/aduit-log";
import AuditLogModal from "Components/Modal/audit-log";
const { RangePicker } = DatePicker;
const disabled7DaysDate = (current, { from }) => {
  if (from) {
    return Math.abs(current.diff(from, "days")) >= 90;
  }
  return false;
};

const AuditLogList = () => {
  const userData = useSelector(loggedInUser);
  const [queryParams, setQueryParams] = useState({
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  });

  const permissions = userData?.permissions;

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: getData,
  } = useGetAuditLogListQuery(
    {
      companyCode: userData?.companyCode,
      ...queryParams,
    },
    {
      enabled: !!userData.companyCode,
    }
  );

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [selectedAuditLog, setSelectedAuditLog] = useState(null);

  const viewAuditLogDetails = (id) => {
    const selectedLog = data?.find((log) => log.auditLogId === id);
    
    setSelectedAuditLog(selectedLog);
    setShow(true);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "auditLogId",
    },
    {
      title: "Audit Tpye",
      dataIndex: "auditTpye",
      key: "auditTpye",
    },
    // {
    //   title: "New Description",
    //   dataIndex: "newDescription",
    //   key: "newDescription",
    // },
    // {
    //   title: "Old Description",
    //   dataIndex: "oldDescription",
    //   key: "oldDescription",
    // },
    {
      title: "Audit Module",
      dataIndex: "auditModule",
      key: "auditModule",
    },
    {
      title: "Audit Time",
      dataIndex: "auditDate",
      key: "auditDate",
      // render: (text, record) => {
      //   format(new Date(text), "hh:mm A");
      // },
    },
    {
      title: "Audit User",
      dataIndex: "auditUser",
      key: "auditUser",
    },
    {
      title: "Action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Link
            className="me-2 p-2"
            // to={${all_routes.audit_log}/${record.auditLogId }`}
            to="#"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              viewAuditLogDetails(record.auditLogId);
            }}
          >
            <Eye className="feather-edit" />
          </Link>

          {/* <Popconfirm
                  title="Are you sure to Delete?"
                  onConfirm={() => removeHolidayHandler(record.Code)}
                >
                  <img src={DeleteIcon} alt="img" />
                </Popconfirm> */}
        </div>
      ),
    },
  ];
  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(data, searchColumns);

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Audit Log</h4>
                <h6>Manage your Audit Log</h6>
              </div>
            </div>
            {/* 
            <ReportTools
              columns={columns}
              data={filteredData}
              fileName={`Email Alert list ${filterDate.fromDate} - ${filterDate.toDate}`}
              pdfTheme="striped"
              refresh={getData}
            /> */}
            {/* {hasPermission(
              permissions,
              "Claims Processing",
              "Manage Claims",
              "haveAdd"
            ) && ( */}

            {/* )} */}
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={true}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12 mb-3">
                          <label className="form-label">Start Date – End Date</label>
                          <RangePicker
                            className="form-control"
                            style={{ display: "flex" }}
                            placeholder="From Date"
                            onChange={(date, dateFormat) => {
                              updateQueryParams("fromDate", dateFormat[0]);
                              updateQueryParams("toDate", dateFormat[1]);
                            }}
                            defaultValue={[
                              dayjs(queryParams.fromDate, "YYYY-MM-DD"),
                              dayjs(queryParams.toDate, "YYYY-MM-DD"),
                            ]}
                            dateFormat="YYYY-MM-DD"
                          />
                        </div>

                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">&nbsp;</label>
                            <Link
                              className="btn btn-filters ms-auto"
                              onClick={getData}
                              type="button"
                            >
                              <i
                                data-feather="search"
                                className="feather-search"
                              />
                              <>Filter</>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Datatable
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                      rowKey={(record) => record.alertConfigId}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AuditLogModal
        mode={""}
        show={show}
        handleClose={handleClose}
        data={selectedAuditLog}
      />
    </div>
  );
};

export default AuditLogList;
